import { Component, ElementRef, ViewChild } from '@angular/core';
import { PopUpComponent } from '@isophi/teachers-shared';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-diagnostic-video',
    templateUrl: './diagnostic-video.component.html',
    styles: [
        `
      ::ng-deep ngb-modal-window app-pop-up-dialog {
        .btn-secondary {
          &:focus {
            background-color: #ffcc38 !important;
          }
        }
      }
    `,
    ],
    standalone: false
})
export class DiagnosticVideoComponent {
  @ViewChild('popUpContent', { static: true })
  public popUpContent: ElementRef;

  public constructor(private popUp: PopUpComponent, private translocoService: TranslocoService) {}

  public async showPopup() {
    const messageTitle = this.translocoService.translate('diagnostics/video/title');
    const confirmText = this.popUpContent.nativeElement.innerHTML;
    const yesText = this.translocoService.translate('kindergarten/back');
    await this.popUp.confirm(messageTitle, confirmText, null, yesText, null, 'btn-secondary', 'btn-outline-dark', 'lg');
  }
}
